import { useEffect, useCallback } from 'react'
import { Toast } from 'antd-mobile'
import http from '@/services/http'
import { useTranslation } from 'react-i18next'
import { useDispatch } from '@/store'
import { useHistory } from 'react-router'
import { Message } from '@/components'
import { useUserLogin } from '../Authorized/hooks'
import { OneClubPathMap, replaceToOneClubUrl } from '@/utils/user'
import i18n from '@/i18n'

import { useHanlde } from './handle'

enum BizCodeEnum {
  SELLER_TO_BUY_CASH_ON_DELIVERY_COUNT = 'LST-123672-B1112',
}

// 不需要全局拦截提示toast的code
// stoken过期: -13， 已注册：2002
const udbWhiteCode = ['-13', '2002']
const adminWhiteCode = ['LST-123677-B0053', 'LST-123677-B0054', 'LST-123677-B0042']

const GlobalError = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { logoutToOnclub } = useUserLogin()

  const { SellerToBuyCashOnDeliveryCountConfirm } = useHanlde()

  const handleErrorCode = useCallback(
    (rejection) => {
      const shouldToast = !adminWhiteCode.includes(rejection?.code) && rejection?.code
      if (shouldToast) {
        const i18nResult = i18n.t([`system.error.${rejection.code}`, rejection.code /*fallback*/], { systemError: rejection.message })

        // 只有匹配到指定的多语言code，才全局提示
        if (i18nResult === i18n.t(`system.error.${rejection.code}`, { systemError: rejection.message })) {
          if (
            !['LST-133242-B9001' /*no login*/, 'LST-133242-B9003'] /*cookie expired*/
              .includes(rejection.code)
          ) {
            if (rejection.bizCode === 'LST-123677-B0031') {
              // 收发件手机号码存在隐私申诉
              Message.error(i18n.t(`system.error.${rejection.bizCode}`, { orderNo: rejection.data?.privacyAppealOrderNos?.join(',') }))
            } else {
              Message.error(i18nResult)
            }
          }
          switch (rejection.code) {
            case 'LST-133242-B9001' /*no login*/:
              replaceToOneClubUrl(OneClubPathMap.login, 'logout')
              break
            case 'LST-133242-B9003' /*cookie expired*/:
              replaceToOneClubUrl(OneClubPathMap.login, 'logout')
              break
          }

          // 修改数据，去掉message等，避免在发起请求者的catch中再次提示message
          return Promise.reject({
            data: null,
            code: rejection.code,
          })
        } else if (rejection?.bizMessage) {
          Message.error(rejection.bizMessage)
        } else if (rejection?.message) {
          Message.error(rejection.message)
        }
      }

      // 业务错误，ui统一处理
      const bizHandleFnMap = {
        [BizCodeEnum.SELLER_TO_BUY_CASH_ON_DELIVERY_COUNT]: SellerToBuyCashOnDeliveryCountConfirm, // cash on delivery 权益不足提示货快照过期
      }
      const fn = bizHandleFnMap[rejection.bizCode]
      if (typeof fn === 'function') {
        fn(rejection.bizCode)
        return true
      }

      return Promise.reject(rejection)
    },
    [SellerToBuyCashOnDeliveryCountConfirm]
  )

  // admin HTTP 拦截器
  useEffect(() => {
    const id = http.admin.interceptors.response.use((response) => {
      return response
    }, handleErrorCode)
    const normalId = http.normal.interceptors.response.use((response) => {
      return response
    }, handleErrorCode)

    return () => {
      http.admin.interceptors.response.eject(id)
      http.normal.interceptors.response.eject(normalId)
    }
  }, [dispatch, handleErrorCode, history, logoutToOnclub, t])

  // udb拦截器
  useEffect(() => {
    const id = http.udb.interceptors.response.use(
      (response) => response,
      (rejection) => {
        const shouldToast = !udbWhiteCode.includes(rejection?.rescode) && rejection?.rescode
        if (shouldToast) {
          const i18nResult = t([`udb.rescode.${rejection.rescode}`, rejection.resmsg /*fallback*/])

          // 只有匹配到指定的多语言code，才全局提示
          if (i18nResult === t(`udb.rescode.${rejection.code}`)) {
            Toast.show({
              content: i18nResult,
            })

            // 修改数据，去掉message等，避免在发起请求者的catch中再次提示message
            return Promise.reject({
              data: null,
              code: rejection.code,
            })
          }
        }

        return Promise.reject(rejection)
      }
    )

    return () => {
      http.admin.interceptors.response.eject(id)
    }
  }, [t])

  return null
}
GlobalError.displayName = 'GlobalError'

export default GlobalError
